import isPropValid from '@emotion/is-prop-valid';

/**
 * Restores styled-components v5 default prop-filtering behavior under v6.
 *
 * v6 no longer filters non-standard props for host (DOM) elements. This
 * forwards a prop to the underlying element only when the target is a DOM
 * element (string tag) and the prop is a valid HTML/SVG attribute; props on
 * custom React components are always forwarded so they can handle their own
 * filtering.
 *
 * @param   {string} prop   The prop name being evaluated.
 * @param   {*}      target The element/component the prop would be forwarded to.
 * @return  {boolean}       Whether the prop should be forwarded to the target.
 */
export const shouldForwardProp = (prop, target) =>
    typeof target === 'string' ? isPropValid(prop) : true;

export default shouldForwardProp;
